import React from 'react';
import './index.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Bootstrap from './Bootstrap';

const boostrap = new Bootstrap();
boostrap.init();

const OriginalResizeObserver = window.ResizeObserver;

(window as any).ResizeObserver = function (callback: any) {
  const wrappedCallback = (entries: any, observer: any) => {
    window.requestAnimationFrame(() => {
      callback(entries, observer);
    });
  };
  return new OriginalResizeObserver(wrappedCallback);
};
for (let staticMethod in OriginalResizeObserver) {
  if (OriginalResizeObserver.hasOwnProperty(staticMethod)) {
    // @ts-ignore
    (window as any).ResizeObserver[staticMethod] = OriginalResizeObserver[staticMethod as any] as any;
  }
}
